import { useEffect } from 'react';

export const useWeakPasswords = getWeakPasswordsRequest => {
    useEffect(() => {
        const timer = setInterval(() => getWeakPasswordsRequest(), 9e5);

        return () => clearInterval(timer);
    }, []);
};
